// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.box-container {
  width: 100%;
  max-width: var(--primary-container-max-width);
  margin-inline: auto;
  padding: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/component/common/box/Box.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,6CAAA;EACA,mBAAA;EACA,aAAA;AACF","sourcesContent":[".box-container {\n  width: 100%;\n  max-width: var(--primary-container-max-width);\n  margin-inline: auto;\n  padding: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
